// Bane 3: Elbil-fredag (2036). Trekantområdet og Aarhus.
// Nyt: årstider med varmeønsker om vinteren, spidsbølger når alle sætter elbilen til på én gang,
// batterier, Lynreserve og Nødaflastning. Finalen: frostfredag kl. 17 i januar, hvor hele området
// tænder for varmen og elbilen samtidig.

import type { LevelDef } from '../../sim/types';

export const LEVEL_03: LevelDef = {
  id: '03-elbil-fredag',
  number: 3,
  title: 'Elbil-fredag',
  year: 2036,
  intro: 'Fredag kl. 17 kommer alle hjem, sætter elbilen til og skruer op for varmen. Lige på én gang.',
  view: [70, 160, 160, 262],
  greenGoalPct: 64,
  sites: [
    { node: 'fredericia', kind: 'city', tier: 2, maxTier: 2 },
    { node: 'vejle', kind: 'city', tier: 1, maxTier: 2 },
    { node: 'give', kind: 'wind', name: 'Give Vind', capMw: 600, fee: 4 },
    // Skærbækværket regnes som gas her (dets spidslast- og reservekedler); Studstrupværket fyrer med
    // træpiller siden 2016 og tæller grønt. Så kan målet nås, når Studstrup og vinden er koblet på.
    { node: 'skaerbaek', kind: 'plant', name: 'Skærbækværket', capMw: 700 },
    { node: 'erritso', kind: 'city', tier: 0, maxTier: 2, at: [8, 15] },
    { node: 'hedensted', kind: 'station', at: [20, 30] },
    // Kunder i køen, i den rækkefølge de dukker op.
    { node: 'juelsminde', kind: 'wind', name: 'Juelsminde Vind', capMw: 300, at: 'pool' },
    { node: 'kolding', kind: 'city', tier: 1, maxTier: 2, at: 'pool' },
    { node: 'horsens', kind: 'city', tier: 0, maxTier: 2, at: 'pool' },
    { node: 'trige', kind: 'solar', name: 'Solpark Trige', capMw: 300, at: 'pool' },
    { node: 'skanderborg', kind: 'city', tier: 0, maxTier: 1, at: 'pool' },
    { node: 'aarhus', kind: 'city', tier: 1, maxTier: 2, at: 'pool' },
    { node: 'studstrup', kind: 'plant', name: 'Studstrupværket', capMw: 700, green: 1, at: 'pool' },
    { node: 'malling', kind: 'city', tier: 0, maxTier: 1, at: 'pool' },
    // Brædstrup og Egtved ligger inde i landet, væk fra kystens ledninger.
    { node: 'braedstrup', kind: 'city', tier: 0, maxTier: 1, at: 'pool' },
    { node: 'egtved', kind: 'solar', name: 'Solpark Egtved', capMw: 250, at: 'pool' },
  ],
  // Skærbækværket står allerede ved Fredericia, og den gamle 150 kV fører videre til Vejle.
  lines: [
    { a: 'skaerbaek', b: 'fredericia', medium: 'air', tier: 2 },
    { a: 'fredericia', b: 'vejle', medium: 'air', tier: 1 },
  ],
  mechanics: ['air', 'upgrade', 'double', 'cable', 'crew', 'reinforce', 'station', 'shoo', 'battery', 'wishes', 'fcr', 'shed'],
  eventMenu: ['storm', 'digger', 'protest', 'spike', 'heatwave'],
  // Ét nyt i hvert år: elbilerne (scriptet i år 1), naboerne, stormen, gravkoen og sommervarmen.
  news: [['spike'], ['protest'], ['storm'], ['digger'], ['heatwave']],
  scripted: [
    // Den første elbil-fredag kommer tidligt, så kortet bliver vist, før det gælder.
    { kind: 'spike', at: [30, 40], strength: 1, trackHalf: 30 },
    // Finalen: frostfredag. Hele området sætter elbilen til, og en storm kommer ind fra vest bagefter.
    { kind: 'spike', at: 6, strength: 3, trackHalf: 200, finale: true },
    { kind: 'storm', at: 22, warnS: 10, strength: 1, finale: true },
  ],
  growth: [],
  boosts: [],
  years: 5,
  finaleS: 40,
  clockFrozenUntilYear: 0,
  startCrews: 1,
  crewHome: 'fredericia',
  packs: [
    ['big_battery', 'two_crews'],
    ['free_air3', 'free_double'],
    ['town_meeting', 'big_battery'],
    ['two_crews', 'free_air3'],
    ['free_station', 'free_air3'],
  ],
};
